import { NavLink } from "react-router-dom";
import { MoreHorizontal } from "lucide-react";
import { useI18n } from "@/context/I18nContext";

export default function MobileBottomNav({ items, onMore }) {
  const { t } = useI18n();
  return (
    <nav
      data-testid="mobile-bottom-nav"
      className="fixed bottom-0 inset-x-0 z-40 lg:hidden border-t border-border bg-background/90 backdrop-blur-xl pb-[env(safe-area-inset-bottom)]"
    >
      <div className="grid h-16" style={{ gridTemplateColumns: `repeat(${items.length + 1}, minmax(0, 1fr))` }}>
        {items.map(({ to, icon: Icon, label }) => (
          <NavLink
            key={to}
            to={to}
            data-testid={`bottom-nav-${to.slice(1).replace(/\//g, "-")}`}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center gap-1 text-[10px] ${
                isActive ? "text-[hsl(var(--success))] font-medium" : "text-muted-foreground"
              }`
            }
          >
            <Icon className="h-5 w-5" />
            <span className="truncate max-w-full px-1">{label}</span>
          </NavLink>
        ))}
        <button
          type="button"
          onClick={onMore}
          data-testid="bottom-nav-more"
          className="flex flex-col items-center justify-center gap-1 text-[10px] text-muted-foreground"
        >
          <MoreHorizontal className="h-5 w-5" />
          <span className="truncate max-w-full px-1">{t("nav_more")}</span>
        </button>
      </div>
    </nav>
  );
}
